import { EnumStorageTransactionType } from '@Model';

/** How long the Zeitpunkt must stay unchanged before the stock is read for it. */
export const STOCK_DEBOUNCE_MS = 400;

/** Which words the line uses: the booking mask, the effect of a stored booking or its cancellation. */
export type StockPreviewMode = 'booking' | 'effect' | 'cancellation';

export interface StockPreviewValues {
    current: number;
    after: number;
}

/** The two values of the line "Bestand jetzt X t → danach Y t", or undefined for an Inventur. */
// @ai-generated 2026-10-23T13:30:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function stockPreview(
    type: EnumStorageTransactionType,
    current: number,
    quantity: number,
): StockPreviewValues | undefined {
    if (type === EnumStorageTransactionType.Stocktaking) {
        return undefined;
    }

    const after = type === EnumStorageTransactionType.Incoming ? current + quantity : current - quantity;
    return { current, after };
}

const effectOf = (type: EnumStorageTransactionType, quantity: number) =>
    type === EnumStorageTransactionType.Incoming ? quantity : -quantity;

/** The stock before and after a stored Zugang or Abgang, from the stock at its instant, or undefined for an Inventur. */
// @ai-generated 2026-10-26T15:00:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function stockEffectPreview(
    type: EnumStorageTransactionType,
    stockAtInstant: number,
    quantity: number,
): StockPreviewValues | undefined {
    if (type === EnumStorageTransactionType.Stocktaking) {
        return undefined;
    }

    return { current: stockAtInstant - effectOf(type, quantity), after: stockAtInstant };
}

/** The stock at the instant of a stored Zugang or Abgang and after its cancellation, or undefined for an Inventur. */
// @ai-generated 2026-10-26T17:30:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function cancellationPreview(
    type: EnumStorageTransactionType,
    stockAtInstant: number,
    quantity: number,
): StockPreviewValues | undefined {
    if (type === EnumStorageTransactionType.Stocktaking) {
        return undefined;
    }

    return { current: stockAtInstant, after: stockAtInstant - effectOf(type, quantity) };
}
